module.exports = __webpack_public_path__ + "img/Cracked-Broken-Yolk-Uncooked-Egg-Shell-Raw-32115.76fdabad.png";